import React from 'react';

import { useSelector } from 'react-redux';

import StaticField from 'components/StaticField';
import { CUSTOMER_EMAIL } from 'modules/Inquiry/Form/formFields';
import { getCustomerData } from 'store/inquiryDetails/selectors';
import { useTranslations } from 'utils/hooks/useTranslations';

const EmailAddressStaticField = () => {
  const customerData = useSelector(getCustomerData);
  const t = useTranslations('pages.customerData.sections.contactPerson.fields.emailAddress');
  return <StaticField caption={t('caption')} text={customerData[CUSTOMER_EMAIL]} />;
};

export default EmailAddressStaticField;
